import { useAtomValue } from 'jotai';
import { SelectField, Tooltip } from '@wk/components-v3-react16';
import { hideTooltipInfoAtom } from '../../../../atoms';
import styles from './Module.module.scss';
import type { ServerModule } from '../../../../ServerWorkflowType';

interface ModuleProperties {
  id?: string;
  module: ServerModule;
  availableVersions?: string[];
  onVersionChange?: (version: string) => void;
}

export const Module = ({
  module,
  id,
  availableVersions,
  onVersionChange,
}: ModuleProperties) => {
  const disabledTooltip = useAtomValue(hideTooltipInfoAtom);
  const hasVersionDropdown = !!availableVersions && !!onVersionChange;
  const versionSelectId = `module-version-${module.textId}`;

  return (
    <>
      <span className={styles.sixDots} />
      <div className={styles.moduleContent} id={id}>
        <div className={styles.moduleName}>{module.name}</div>
        {hasVersionDropdown ? (
          <SelectField
            srLabel={`${module.name} version`}
            size="medium"
            labelFor={versionSelectId}
          >
            <select
              id={versionSelectId}
              className={styles.moduleVersion}
              value={module.version}
              onMouseDown={(event) => event.stopPropagation()}
              onTouchStart={(event) => event.stopPropagation()}
              onChange={(event) => onVersionChange(event.target.value)}
            >
              {availableVersions.map((version) => (
                <option key={version} value={version}>
                  {version}
                </option>
              ))}
            </select>
          </SelectField>
        ) : (
          <div className={styles.moduleVersion}>{module.version}</div>
        )}
      </div>
      {!disabledTooltip && (
        <Tooltip
          mode="description"
          targetSelector={`#${id}`}
          elementId="description"
        >
          Select this option to explore further customization settings
        </Tooltip>
      )}
    </>
  );
};

export default Module;


